import { Trans } from "@lingui/react/macro";
import { observer } from "mobx-react-lite";
import React from "react";

import { DataModel } from "../../../models/data-model";
import {
  Dialog as BaseDialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../base/dialog";
import { Button } from "../button";

export const ChoosingModal = observer(function ChoosingModal({
  model,
  title,
  onConfirm,
  onClose,
  table,
  readOnly,
  loading,
  fillHeight,
}: {
  model?: DataModel;
  title: React.ReactNode;
  onConfirm: (params: { selected: any[] }) => void;
  onClose: () => void;
  table: React.ReactNode;
  readOnly?: boolean;
  loading?: boolean;
  /**
   * The table scrolls its own rows (pass `fillHeight` to DataTable too)
   * instead of the whole table region scrolling inside the modal.
   */
  fillHeight?: boolean;
}) {
  const closeModal = () => {
    onClose();
  };

  return (
    <BaseDialog
      open
      onOpenChange={(open) => {
        if (!open) {
          closeModal();
        }
      }}
    >
      <DialogContent className="max-h-[80vh] overflow-hidden sm:max-w-[calc(100vw-4rem)]">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>

        <div
          className={
            fillHeight
              ? "min-h-0 flex-1 flex flex-col"
              : "min-h-0 flex-1 overflow-y-auto"
          }
        >
          {loading ? <Trans>Loading...</Trans> : table}
        </div>

        {!readOnly && model && !loading && (
          <DialogFooter>
            <Button onClick={closeModal}>
              <Trans>Cancel</Trans>
            </Button>
            <Button
              disabled={
                model.selectionMode === "single" && model.selected.length === 0
              }
              onClick={() => {
                onConfirm({ selected: [...model.selected] });
                closeModal();
              }}
            >
              <Trans>Confirm</Trans>
            </Button>
          </DialogFooter>
        )}
      </DialogContent>
    </BaseDialog>
  );
});
